import { render, staticRenderFns } from "./FabricCategoryMatchings.vue?vue&type=template&id=0f682ad2&scoped=true"
import script from "./FabricCategoryMatchings.vue?vue&type=script&lang=js"
export * from "./FabricCategoryMatchings.vue?vue&type=script&lang=js"
import style0 from "./FabricCategoryMatchings.vue?vue&type=style&index=0&id=0f682ad2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f682ad2",
  null
  
)

export default component.exports